/* SALTY NOVA CUSTOMISATION: pairs with sections/feature-carousel.liquid.
   Keeps dot pagination in sync with native scroll via IntersectionObserver
   (no scroll-event listeners), and lets a dot click jump to its card. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  document.querySelectorAll('.sn-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.sn-carousel__track');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-sn-carousel-card]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-sn-carousel-dot]'));
    if (!cards.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(cards.indexOf(entry.target));
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    setActive(0);
  });
})();
